export default function WalleyLoadingSkeleton() {
  return (
    <div className="mx-auto mb-3 flex w-full max-w-screen-sm flex-col gap-3 p-3">
      <div className="flex flex-col gap-1.5">
        <div className="h-7 max-w-32 grow animate-pulse bg-grey-100" />
        <div className="h-4 max-w-60 grow animate-pulse bg-grey-100" />
      </div>
      <div>
        <div className="h-14 w-full animate-pulse bg-grey-100" />
        <div className="h-14 w-full animate-pulse bg-grey-100" />
      </div>
      <div className="flex gap-3">
        <div className="h-4 max-w-16 grow animate-pulse bg-grey-100" />
        <div className="h-4 max-w-32 grow animate-pulse bg-grey-100" />
      </div>
      <div className="ml-auto h-12 w-full max-w-24 animate-pulse bg-grey-100" />
      <div className="h-7 w-full max-w-24 animate-pulse bg-grey-100" />
      <div className="h-14 w-full animate-pulse bg-grey-100" />
      <div className="flex flex-col gap-1.5">
        <div className="mx-auto h-4 w-full max-w-64 animate-pulse bg-grey-100" />
        <div className="mx-auto h-8 w-full max-w-40 animate-pulse bg-grey-100" />
      </div>
      <div className="mx-auto h-14 w-full max-w-96 animate-pulse bg-grey-100" />
      <div className="flex place-content-center gap-3">
        <div className="h-4 max-w-24 grow animate-pulse bg-grey-100" />
        <div className="h-4 max-w-32 grow animate-pulse bg-grey-100" />
        <div className="h-4 max-w-16 grow animate-pulse bg-grey-100" />
      </div>
    </div>
  );
}
